exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "@media screen and (max-width: 750px) {\n.column_li[data-v-4dad8d3c] {\n    width: 100%;\n    height: auto;\n    border-bottom: 1px solid #eee;\n}\n.column_li_box[data-v-4dad8d3c] {\n    padding: 0 20px;\n    background-color: #fff;\n}\n}\n", ""]);

